import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { action } from 'mobx';
import { FormattedMessage } from 'ui/i18n';

import './SubmitWithoutUpdatesModal.scss';

@inject('CartItemsState', 'CartState')
@observer
export default class SubmitWithoutUpdatesModal extends Component {
	static propTypes = {
		CartItemsState: PropTypes.object.isRequired,
		CartState: PropTypes.object.isRequired,
		show: PropTypes.bool.isRequired,
		onRequestClose: PropTypes.func.isRequired,
		onSubmit: PropTypes.func.isRequired,
	};

	@action
	onClick() {
		this.props.CartItemsState.emptyCurrentCart();
		this.props.CartState.replaceCart(this.props.CartState.cart, false);
		this.props.onSubmit();
		this.props.onRequestClose();
	}

	@action
	onCancel() {
		this.props.onRequestClose();
	}

	render() {
		const { show } = this.props;

		return (
			<Modal
				className="ReactModal__Content SubmitWithoutUpdates"
				overlayClassName="ReactModal__Overlay"
				isOpen={show}
				onRequestClose={this.onCancel.bind(this)}
				contentLabel="Submit Order"
			>
				<h4>
					<strong>
						<FormattedMessage id="cart.submitOrder" />
					</strong>
				</h4>
				<hr />
				<h5>
					<FormattedMessage id="cart.submitWithoutUpdate" />
				</h5>

				<div className="row rightSide">
					<button
						className="btn btn-default pull-right submit-with-updates-cancel"
						onClick={this.onCancel.bind(this)}
					>
						<FormattedMessage id="general.cancelText" />
					</button>
					<button
						className="btn btn-primary pull-right"
						onClick={this.onClick.bind(this)}
					>
						<FormattedMessage id="cart.submitWithoutUpdatesYes" />
					</button>
				</div>
			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/SubmitWithoutUpdatesModal/index.js